/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CastaiAuditV1beta1AuditEntry } from '../models';
// @ts-ignore
import type { CastaiAuditV1beta1ListAuditEntriesResponse } from '../models';
// @ts-ignore
import type { CastaiAuditV1beta1ListAuditEventsResponse } from '../models';
/**
 * AuditAPIApi - axios parameter creator
 * @export
 */
export const AuditAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary GetAuditEvent returns a specific audit event.
         * @param {string} id The audit entry record ID.
         * @param {string} time The date and time the audit event record was created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditAPIGetAuditEvent: async (id: string, time: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('auditAPIGetAuditEvent', 'id', id)
            // verify required parameter 'time' is not null or undefined
            assertParamExists('auditAPIGetAuditEvent', 'time', time)
            const localVarPath = `/v1/audit-events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (time !== undefined) {
                localVarQueryParameter['time'] = (time as any instanceof Date) ?
                    (time as any).toISOString() :
                    time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ListAuditEntries returns audit entries for given cluster.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [clusterId] the cluster id to filter by
         * @param {string} [fromDate] from_date is a timestamp to filter audits from
         * @param {string} [toDate] to_date is a timestamp to filter audits to
         * @param {string} [labels] labels is a map of labels to filter audits by  This is a request variable of the map type. The query format is \&quot;map_name[key]&#x3D;value\&quot;, e.g. If the map name is Age, the key type is string, and the value type is integer, the query parameter is expressed as Age[\&quot;bob\&quot;]&#x3D;18
         * @param {string} [operation] operation is a string to filter audits by
         * @param {string} [initiatedById] initiated_by_id is a string to filter audits by ID of the user who initiated the operation
         * @param {string} [initiatedByEmail] initiated_by_email is a string to filter audits by email of the user who initiated the operation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditAPIListAuditEntries: async (pageLimit?: string, pageCursor?: string, clusterId?: string, fromDate?: string, toDate?: string, labels?: string, operation?: string, initiatedById?: string, initiatedByEmail?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (labels !== undefined) {
                localVarQueryParameter['labels'] = labels;
            }

            if (operation !== undefined) {
                localVarQueryParameter['operation'] = operation;
            }

            if (initiatedById !== undefined) {
                localVarQueryParameter['initiatedById'] = initiatedById;
            }

            if (initiatedByEmail !== undefined) {
                localVarQueryParameter['initiatedByEmail'] = initiatedByEmail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ListAuditEvents is the second version of the audit events endpoint.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [clusterId] The unique cluster identifier.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The maximum date and time to query to.
         * @param {string} [labels] This is a request variable of the map type. The query format is \&quot;map_name[key]&#x3D;value\&quot;, e.g. If the map name is Age, the key type is string, and the value type is integer, the query parameter is expressed as Age[\&quot;bob\&quot;]&#x3D;18
         * @param {string} [operation] The audit entry operation.
         * @param {string} [initiatedById] Unique identifier of the user who initiated the operation.
         * @param {string} [initiatedByEmail] E-mail of the user who initiated the operation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditAPIListAuditEvents: async (pageLimit?: string, pageCursor?: string, clusterId?: string, fromDate?: string, toDate?: string, labels?: string, operation?: string, initiatedById?: string, initiatedByEmail?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/audit-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (clusterId !== undefined) {
                localVarQueryParameter['clusterId'] = clusterId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (labels !== undefined) {
                localVarQueryParameter['labels'] = labels;
            }

            if (operation !== undefined) {
                localVarQueryParameter['operation'] = operation;
            }

            if (initiatedById !== undefined) {
                localVarQueryParameter['initiatedById'] = initiatedById;
            }

            if (initiatedByEmail !== undefined) {
                localVarQueryParameter['initiatedByEmail'] = initiatedByEmail;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditAPIApi - functional programming interface
 * @export
 */
export const AuditAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary GetAuditEvent returns a specific audit event.
         * @param {string} id The audit entry record ID.
         * @param {string} time The date and time the audit event record was created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditAPIGetAuditEvent(id: string, time: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV1beta1AuditEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditAPIGetAuditEvent(id, time, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditAPIApi.auditAPIGetAuditEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ListAuditEntries returns audit entries for given cluster.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [clusterId] the cluster id to filter by
         * @param {string} [fromDate] from_date is a timestamp to filter audits from
         * @param {string} [toDate] to_date is a timestamp to filter audits to
         * @param {string} [labels] labels is a map of labels to filter audits by  This is a request variable of the map type. The query format is \&quot;map_name[key]&#x3D;value\&quot;, e.g. If the map name is Age, the key type is string, and the value type is integer, the query parameter is expressed as Age[\&quot;bob\&quot;]&#x3D;18
         * @param {string} [operation] operation is a string to filter audits by
         * @param {string} [initiatedById] initiated_by_id is a string to filter audits by ID of the user who initiated the operation
         * @param {string} [initiatedByEmail] initiated_by_email is a string to filter audits by email of the user who initiated the operation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditAPIListAuditEntries(pageLimit?: string, pageCursor?: string, clusterId?: string, fromDate?: string, toDate?: string, labels?: string, operation?: string, initiatedById?: string, initiatedByEmail?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV1beta1ListAuditEntriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditAPIListAuditEntries(pageLimit, pageCursor, clusterId, fromDate, toDate, labels, operation, initiatedById, initiatedByEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditAPIApi.auditAPIListAuditEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ListAuditEvents is the second version of the audit events endpoint.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [clusterId] The unique cluster identifier.
         * @param {string} [fromDate] The date and time to query from.
         * @param {string} [toDate] The maximum date and time to query to.
         * @param {string} [labels] This is a request variable of the map type. The query format is \&quot;map_name[key]&#x3D;value\&quot;, e.g. If the map name is Age, the key type is string, and the value type is integer, the query parameter is expressed as Age[\&quot;bob\&quot;]&#x3D;18
         * @param {string} [operation] The audit entry operation.
         * @param {string} [initiatedById] Unique identifier of the user who initiated the operation.
         * @param {string} [initiatedByEmail] E-mail of the user who initiated the operation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auditAPIListAuditEvents(pageLimit?: string, pageCursor?: string, clusterId?: string, fromDate?: string, toDate?: string, labels?: string, operation?: string, initiatedById?: string, initiatedByEmail?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CastaiAuditV1beta1ListAuditEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auditAPIListAuditEvents(pageLimit, pageCursor, clusterId, fromDate, toDate, labels, operation, initiatedById, initiatedByEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditAPIApi.auditAPIListAuditEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditAPIApi - factory interface
 * @export
 */
export const AuditAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary GetAuditEvent returns a specific audit event.
         * @param {AuditAPIApiAuditAPIGetAuditEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditAPIGetAuditEvent(requestParameters: AuditAPIApiAuditAPIGetAuditEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV1beta1AuditEntry> {
            return localVarFp.auditAPIGetAuditEvent(requestParameters.id, requestParameters.time, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ListAuditEntries returns audit entries for given cluster.
         * @param {AuditAPIApiAuditAPIListAuditEntriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditAPIListAuditEntries(requestParameters: AuditAPIApiAuditAPIListAuditEntriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV1beta1ListAuditEntriesResponse> {
            return localVarFp.auditAPIListAuditEntries(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.clusterId, requestParameters.fromDate, requestParameters.toDate, requestParameters.labels, requestParameters.operation, requestParameters.initiatedById, requestParameters.initiatedByEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ListAuditEvents is the second version of the audit events endpoint.
         * @param {AuditAPIApiAuditAPIListAuditEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auditAPIListAuditEvents(requestParameters: AuditAPIApiAuditAPIListAuditEventsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CastaiAuditV1beta1ListAuditEventsResponse> {
            return localVarFp.auditAPIListAuditEvents(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.clusterId, requestParameters.fromDate, requestParameters.toDate, requestParameters.labels, requestParameters.operation, requestParameters.initiatedById, requestParameters.initiatedByEmail, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for auditAPIGetAuditEvent operation in AuditAPIApi.
 * @export
 * @interface AuditAPIApiAuditAPIGetAuditEventRequest
 */
export interface AuditAPIApiAuditAPIGetAuditEventRequest {
    /**
     * The audit entry record ID.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIGetAuditEvent
     */
    readonly id: string

    /**
     * The date and time the audit event record was created.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIGetAuditEvent
     */
    readonly time: string
}

/**
 * Request parameters for auditAPIListAuditEntries operation in AuditAPIApi.
 * @export
 * @interface AuditAPIApiAuditAPIListAuditEntriesRequest
 */
export interface AuditAPIApiAuditAPIListAuditEntriesRequest {
    /**
     * 
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEntries
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEntries
     */
    readonly pageCursor?: string

    /**
     * the cluster id to filter by
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEntries
     */
    readonly clusterId?: string

    /**
     * from_date is a timestamp to filter audits from
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEntries
     */
    readonly fromDate?: string

    /**
     * to_date is a timestamp to filter audits to
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEntries
     */
    readonly toDate?: string

    /**
     * labels is a map of labels to filter audits by  This is a request variable of the map type. The query format is \&quot;map_name[key]&#x3D;value\&quot;, e.g. If the map name is Age, the key type is string, and the value type is integer, the query parameter is expressed as Age[\&quot;bob\&quot;]&#x3D;18
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEntries
     */
    readonly labels?: string

    /**
     * operation is a string to filter audits by
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEntries
     */
    readonly operation?: string

    /**
     * initiated_by_id is a string to filter audits by ID of the user who initiated the operation
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEntries
     */
    readonly initiatedById?: string

    /**
     * initiated_by_email is a string to filter audits by email of the user who initiated the operation
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEntries
     */
    readonly initiatedByEmail?: string
}

/**
 * Request parameters for auditAPIListAuditEvents operation in AuditAPIApi.
 * @export
 * @interface AuditAPIApiAuditAPIListAuditEventsRequest
 */
export interface AuditAPIApiAuditAPIListAuditEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEvents
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEvents
     */
    readonly pageCursor?: string

    /**
     * The unique cluster identifier.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEvents
     */
    readonly clusterId?: string

    /**
     * The date and time to query from.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEvents
     */
    readonly fromDate?: string

    /**
     * The maximum date and time to query to.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEvents
     */
    readonly toDate?: string

    /**
     * This is a request variable of the map type. The query format is \&quot;map_name[key]&#x3D;value\&quot;, e.g. If the map name is Age, the key type is string, and the value type is integer, the query parameter is expressed as Age[\&quot;bob\&quot;]&#x3D;18
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEvents
     */
    readonly labels?: string

    /**
     * The audit entry operation.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEvents
     */
    readonly operation?: string

    /**
     * Unique identifier of the user who initiated the operation.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEvents
     */
    readonly initiatedById?: string

    /**
     * E-mail of the user who initiated the operation.
     * @type {string}
     * @memberof AuditAPIApiAuditAPIListAuditEvents
     */
    readonly initiatedByEmail?: string
}

/**
 * AuditAPIApi - object-oriented interface
 * @export
 * @class AuditAPIApi
 * @extends {BaseAPI}
 */
export class AuditAPIApi extends BaseAPI {
    /**
     * 
     * @summary GetAuditEvent returns a specific audit event.
     * @param {AuditAPIApiAuditAPIGetAuditEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditAPIApi
     */
    public auditAPIGetAuditEvent(requestParameters: AuditAPIApiAuditAPIGetAuditEventRequest, options?: RawAxiosRequestConfig) {
        return AuditAPIApiFp(this.configuration).auditAPIGetAuditEvent(requestParameters.id, requestParameters.time, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ListAuditEntries returns audit entries for given cluster.
     * @param {AuditAPIApiAuditAPIListAuditEntriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditAPIApi
     */
    public auditAPIListAuditEntries(requestParameters: AuditAPIApiAuditAPIListAuditEntriesRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditAPIApiFp(this.configuration).auditAPIListAuditEntries(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.clusterId, requestParameters.fromDate, requestParameters.toDate, requestParameters.labels, requestParameters.operation, requestParameters.initiatedById, requestParameters.initiatedByEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ListAuditEvents is the second version of the audit events endpoint.
     * @param {AuditAPIApiAuditAPIListAuditEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditAPIApi
     */
    public auditAPIListAuditEvents(requestParameters: AuditAPIApiAuditAPIListAuditEventsRequest = {}, options?: RawAxiosRequestConfig) {
        return AuditAPIApiFp(this.configuration).auditAPIListAuditEvents(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.clusterId, requestParameters.fromDate, requestParameters.toDate, requestParameters.labels, requestParameters.operation, requestParameters.initiatedById, requestParameters.initiatedByEmail, options).then((request) => request(this.axios, this.basePath));
    }
}

